/**
 * Compact luxury social icons: TikTok + Pinterest (Lucide doesn't ship these).
 * Stroke = currentColor for theme alignment.
 */
export function TikTokIcon({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M19.6 6.7a4.9 4.9 0 0 1-3.1-1.1A4.9 4.9 0 0 1 14.9 2h-3v13.4a2.6 2.6 0 1 1-2.6-2.6c.27 0 .53.04.78.12V9.86A6.18 6.18 0 0 0 9.3 9.7 5.7 5.7 0 1 0 15 15.4V9.27a8 8 0 0 0 4.6 1.45V7.6a5.16 5.16 0 0 1 0-.9z"/>
    </svg>
  );
}

export function PinterestIcon({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M12 2C6.48 2 2 6.48 2 12c0 4.09 2.45 7.6 5.96 9.16-.08-.78-.15-1.97.03-2.82.16-.77 1.05-4.92 1.05-4.92s-.27-.54-.27-1.34c0-1.25.73-2.19 1.63-2.19.77 0 1.14.58 1.14 1.27 0 .77-.49 1.93-.75 3.01-.21.9.45 1.64 1.34 1.64 1.61 0 2.85-1.7 2.85-4.15 0-2.17-1.56-3.69-3.79-3.69-2.58 0-4.1 1.94-4.1 3.94 0 .78.3 1.62.67 2.07.07.09.08.17.06.26-.07.27-.21.84-.24.96-.04.16-.13.19-.29.12-1.1-.51-1.79-2.12-1.79-3.42 0-2.78 2.02-5.34 5.83-5.34 3.06 0 5.43 2.18 5.43 5.09 0 3.04-1.92 5.49-4.58 5.49-.9 0-1.74-.47-2.03-1.02 0 0-.45 1.7-.55 2.12-.2.77-.74 1.74-1.1 2.33C9.94 21.84 10.95 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z"/>
    </svg>
  );
}
